module.exports = __webpack_public_path__ + "media/4.365c7e52.mp3";